export const BUSINESS_TYPES = [
    "Health System",
    "Hospital",
    "Surgery Center",
    "Skilled Nursing Facility",
    "Assisted Living Facility",
    "Home Care",
    "Other",
    "I am a nurse",
];

export const CSU_CERTIFICATIONS = [
    "Center Executive Director",
    "Certified Sterile Technologist",
    "Certified Surgical Technologist",
    "Cook",
    "Diagnostician",
    "Dietary Aide",
    "Director of Health Services",
    "Director of Nursing",
    "Floor Tech",
    "Housekeeping Aid",
    "Housekeeping Aide",
    "Laundry Aid",
    "Laundry Aide",
    "Licensed Clinical Social Worker",
    "LPN",
    "LVN",
    "Maintenance",
    "Nurse Practitioner",
    "Occupational Therapist",
    "Operating Room Tech",
    "Pharmacy Technician",
    "Phlebotomist",
    "Physical Therapist",
    "Psychologist",
    "Radiation Tech",
    "Radiation Therapist",
    "Radiology Technician",
    "Registered Behavior Technician",
    "Respiratory Therapist",
    "RN",
    "RN Supervisor",
    "School Psych",
    "SLP",
    "Sterile Processing Technician",
    "Surgical Technician",
];

export const PERSONAL_EMAIL_DOMAINS_BLACKLIST = [
    "gmail.com",
    "icloud.com",
    "hotmail.com",
    "yahoo.com",
    "live.com",
    "ymail.com",
    "cox.net",
];

export const TRACKABLEZOOMINFOPATHS = [
    "/",
    "/providers/post-acute/",
    "/providers/at-home/",
    "/products/shiftmed-flex/",
    "/products/shiftmed-on-demand/",
    "/products/shiftmed-unlimited-network/",
    "/integrations/",
    "/blog/",
    "/contact/",
];

export const GATED_FORM_SOURCE_TITLE = {
    case_study: "Get Case Study",
    white_paper: "Get White Paper",
    ebook: "Get eBook",
};
